module.exports = __webpack_public_path__ + "img/download.5f6efd24.svg";